import { render, staticRenderFns } from "./ProposalTutorialSlide.vue?vue&type=template&id=0152f5ae"
import script from "./ProposalTutorialSlide.vue?vue&type=script&lang=js"
export * from "./ProposalTutorialSlide.vue?vue&type=script&lang=js"
import style0 from "./ProposalTutorialSlide.vue?vue&type=style&index=0&id=0152f5ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports